import './LayoutStyle.less';

import * as React from 'react';

import { FooterBrokerage } from '@opendoor/bricks';
import { DisclaimerType } from '@opendoor/bricks/components/layout/FooterBrokerage';
import FullHeader from '../../containers/common/FullHeader';
import { IBrokerageInfo } from '../../declarations';
import Footer from './Footer';
import FullFooter from './FullFooter';

export type HeaderType =
  | 'FULL'
  | 'HIDE_NAV'
  | 'MINIMAL'
  | 'BROKERAGE'
  | 'NONE'
  | 'BROKERAGE_MINIMAL';
export type FooterType = 'FULL' | 'MINIMAL' | 'PHOTO' | 'BROKERAGE' | 'NONE';

export interface IProps {
  footerType?: FooterType;
  headerType?: HeaderType;
  hideHeaderMobile?: boolean;
  brokerageInfo?: IBrokerageInfo;
  disclaimerType?: DisclaimerType;
}

export default class Layout extends React.PureComponent<IProps> {
  public static defaultProps: Partial<IProps> = {
    footerType: 'MINIMAL',
    headerType: 'FULL',
    hideHeaderMobile: false,
  };

  public render() {
    const { footerType, headerType, hideHeaderMobile, brokerageInfo, disclaimerType } = this.props;
    const footer = this.getFooter(footerType, brokerageInfo, disclaimerType);
    const header = this.getHeader(headerType, hideHeaderMobile);

    return (
      <div className="od-layout light-theme light-theme-mobile">
        {header}
        <div>{this.props.children}</div>
        {footer}
      </div>
    );
  }

  private getFooter(
    footerType: FooterType,
    brokerageInfo?: IBrokerageInfo,
    disclaimerType?: DisclaimerType,
  ) {
    switch (footerType) {
      case 'FULL':
        return <FullFooter />;
      case 'MINIMAL':
        return <Footer />;
      case 'PHOTO':
        return <Footer showPhoto={true} />;
      case 'BROKERAGE':
        return brokerageInfo ? (
          <FooterBrokerage brokerageInfo={brokerageInfo} disclaimerType={disclaimerType} />
        ) : null;
      case 'NONE':
        return null;
    }
  }

  private getHeader(headerType: HeaderType, hideHeaderMobile: boolean) {
    switch (headerType) {
      case 'FULL':
        return <FullHeader hiddenMobile={hideHeaderMobile} />;
      case 'HIDE_NAV':
        return <FullHeader hideNav={true} hiddenMobile={hideHeaderMobile} />;
      case 'MINIMAL':
        return <FullHeader hideAccount={true} hideNav={true} hiddenMobile={hideHeaderMobile} />;
      case 'BROKERAGE':
        return (
          <FullHeader hideNav={true} hiddenMobile={hideHeaderMobile} showBrokerageLogo={true} />
        );
      case 'BROKERAGE_MINIMAL':
        return (
          <FullHeader
            hideAccount={true}
            hideNav={true}
            hiddenMobile={hideHeaderMobile}
            hideBorder={true}
            showBrokerageLogo={true}
          />
        );
      case 'NONE':
        return null;
    }
  }
}
